import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MobileApi from './utils/mobile'
import vuetify from './plugins/vuetify';
import VueResource from 'vue-resource';
Vue.use(VueResource);

Vue.config.productionTip = false
Vue.use(vuetify, {
  theme: {
    primary: '#93278F',
    secondary: '#93278F',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#F5821F'
  }
})
new Vue({
  router,
  store,
  vuetify,
  created() {
    window.MobileApi = MobileApi;
    window.MobileApi.setDevice();
    window.MobileApi.setStore(this.$store);
    window.MobileApi.getSessionId();

    console.log(window.MobileApi.device);
    this.mobileOns()
  },
  methods: {
    mobileOns() {
      window.addEventListener('onInvoiceUploaded', function () {
        console.log('onInvoiceUploaded')
      }, false)
      window.addEventListener('onBarCodeReaderSuccess', function () {
        console.log('onBarCodeReaderSuccess')
      }, false)
      window.addEventListener('onGetDeviceInfo', function () {
        console.log('onGetDeviceInfo')
      }, false)
      window.addEventListener('onBarCodeReaderError', function () {
        console.log('onBarCodeReaderError')
      }, false)
      window.addEventListener('onGetSessionId', function (e, a) {
        console.log(e.detail);
        console.log(a);
        //  console.log(pushId);
        //  if (userName === "" || userName === null || userName === "null" || userName === undefined && pushId === "" || pushId === null || pushId === "null" || pushId === undefined) {
        //    console.log('onGetSessionId')
        //  } else {
        //   store.dispatch('setUser', {
        //     userName: userName,
        //     pushId: pushId
        //   })
        //  }
      }, false)
      window.addEventListener('onSetSessionId', function (userName, pushId) {
        console.log(userName);
        console.log(pushId);
        if (userName === "" || userName === null || userName === "null" || userName === undefined && pushId === "" || pushId === null || pushId === "null" || pushId === undefined) {
          console.log('onSetSessionId')
        } else {
          store.dispatch('setUser', {
            userName: userName,
            pushId: pushId
          })
        }

      }, false)
      window.addEventListener('onInternetFail', function () {
        console.log('onInternetFail')
      }, false)
      window.addEventListener('onInternetReturn', function () {
        console.log('onInternetReturn')
      }, false)
      window.addEventListener('onOpenApp', function () {
        console.log('onOpenApp')
      }, false)
    }
  },
  render: h => h(App)
}).$mount('#app')